export default function createLayoutModule() {
    return {
        namespaced: true,

        state: () => ({
            showPopUp: false,
            paths: [],
            timestamp: Date.now()
        }),

        getters: {
            showPopUp: (state) => state.showPopUp,
            paths: (state) => state.paths,
            timestamp: (state) => state.timestamp,
        },

        actions: {

        },

        mutations: {
            setPaths(state, value){
                state.paths = value;
                state.timestamp = Date.now();
            },
            pushPath(state, value){
                state.paths.push(value);
                state.timestamp = Date.now();
            },
            closePopUp(state){
                state.showPopUp = false;
            },
            openPopUp(state){
                state.showPopUp = true;
            },
            setShowPopUp(state, value){
                state.showPopUp = value;
            }
        },
    }
}
